import { isValid, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const pacificTimeZone = 'America/Los_Angeles';

export const parseFromPacificTimezoneDate = (dateString: string): Date | undefined => {
  const date = parseISO(dateString);
  if (isValid(date) === false) {
    return undefined;
  }
  return utcToZonedTime(date, pacificTimeZone);
}
